import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex h-full sm:min-h-full items-end sm:items-center justify-center p-0 sm:p-4" };
const _hoisted_2 = { class: "flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 bg-gray-50" };
const _hoisted_3 = { class: "text-lg sm:text-xl font-bold text-gray-900" };
const _hoisted_4 = { class: "flex-1 p-4 sm:p-6 overflow-y-auto" };
const _hoisted_5 = { class: "flex gap-3 p-4 sm:p-6 border-t border-gray-200 bg-gray-50" };
const _hoisted_6 = ["disabled"];
import { ref, computed, watch, inject } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactDataModal',
    props: {
        isOpen: { type: Boolean },
        modelValue: {}
    },
    emits: ["update:isOpen", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Get theme config
        const projectConfig = inject('projectConfig', null);
        const modalButtonPrimary = computed(() => projectConfig?.branding?.modals?.buttons?.primaryBackground || projectConfig?.branding?.colors?.primary || '#DC2626');
        const modalInputFocusBorder = computed(() => projectConfig?.branding?.modals?.inputs?.focusBorderColor || projectConfig?.branding?.colors?.primary || '#DC2626');
        const modalInputFocusRing = computed(() => projectConfig?.branding?.modals?.inputs?.focusRingColor || 'rgba(220, 38, 38, 0.2)');
        const themeIconColor = computed(() => projectConfig?.branding?.colors?.primary || '#DC2626');
        const localData = ref({
            name: '',
            email: '',
            phone: ''
        });
        // Load data when modal opens
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                localData.value = {
                    name: props.modelValue.name,
                    email: props.modelValue.email,
                    phone: props.modelValue.phone
                };
            }
        });
        const isValid = computed(() => {
            return localData.value.name.trim().length > 0 &&
                localData.value.email.trim().length > 0 &&
                localData.value.email.includes('@');
        });
        function closeModal() {
            emit('update:isOpen', false);
        }
        function handleOverlayClick(event) {
            if (event.target === event.currentTarget) {
                closeModal();
            }
        }
        function saveData() {
            if (!isValid.value)
                return;
            const updatedCustomer = {
                ...props.modelValue,
                name: localData.value.name,
                email: localData.value.email,
                phone: localData.value.phone
            };
            emit('update:modelValue', updatedCustomer);
            closeModal();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_ctx.isOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fixed inset-0 z-[100] overflow-y-auto font-roboto",
                        onClick: handleOverlayClick
                    }, [
                        _createCommentVNode(" Backdrop "),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300" }, null, -1 /* CACHED */)),
                        _createCommentVNode(" Modal "),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", {
                                class: "relative bg-white w-full h-full sm:h-auto sm:max-w-lg sm:rounded-xl shadow-xl transform transition-all duration-300 overflow-hidden flex flex-col",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"]))
                            }, [
                                _createCommentVNode(" Modal Header "),
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("h2", _hoisted_3, [
                                        _createElementVNode("i", {
                                            class: "fas fa-user mr-2 sm:mr-3",
                                            style: _normalizeStyle({ color: themeIconColor.value })
                                        }, null, 4 /* STYLE */),
                                        _cache[4] || (_cache[4] = _createTextVNode(" Kontaktdaten ", -1 /* CACHED */))
                                    ]),
                                    _createElementVNode("button", {
                                        onClick: closeModal,
                                        class: "p-2 hover:bg-gray-200 rounded-full transition-colors duration-200"
                                    }, [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("i", { class: "fas fa-times text-gray-600 text-lg sm:text-xl" }, null, -1 /* CACHED */)
                                        ]))])
                                ]),
                                _createCommentVNode(" Modal Content "),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(saveData, ["prevent"]),
                                        class: "space-y-4 sm:space-y-6",
                                        autocomplete: "on"
                                    }, [
                                        _createElementVNode("div", null, [
                                            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                                                _createElementVNode("i", { class: "fas fa-user text-gray-400 mr-2" }),
                                                _createTextVNode(" Name * ")
                                            ], -1 /* CACHED */)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localData.value.name) = $event)),
                                                name: "name",
                                                type: "text",
                                                autocomplete: "name",
                                                required: "",
                                                class: "modal-input w-full px-3 py-2 text-gray-700 border border-gray-300 rounded-md focus:outline-none transition-colors",
                                                style: _normalizeStyle({
                                                    '--focus-border-color': modalInputFocusBorder.value,
                                                    '--focus-ring-color': modalInputFocusRing.value
                                                }),
                                                placeholder: "Ihr vollständiger Name"
                                            }, null, 4 /* STYLE */), [
                                                [_vModelText, localData.value.name]
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                                                _createElementVNode("i", { class: "fas fa-envelope text-gray-400 mr-2" }),
                                                _createTextVNode(" E-Mail * ")
                                            ], -1 /* CACHED */)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localData.value.email) = $event)),
                                                name: "email",
                                                type: "email",
                                                autocomplete: "email",
                                                required: "",
                                                class: "modal-input w-full px-3 py-2 text-gray-700 border border-gray-300 rounded-md focus:outline-none transition-colors",
                                                style: _normalizeStyle({
                                                    '--focus-border-color': modalInputFocusBorder.value,
                                                    '--focus-ring-color': modalInputFocusRing.value
                                                }),
                                                placeholder: "ihre.email@beispiel.de"
                                            }, null, 4 /* STYLE */), [
                                                [_vModelText, localData.value.email]
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                                                _createElementVNode("i", { class: "fas fa-phone text-gray-400 mr-2" }),
                                                _createTextVNode(" Telefonnummer * ")
                                            ], -1 /* CACHED */)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localData.value.phone) = $event)),
                                                name: "tel",
                                                type: "tel",
                                                autocomplete: "tel",
                                                class: "modal-input w-full px-3 py-2 text-gray-700 border border-gray-300 rounded-md focus:outline-none transition-colors",
                                                style: _normalizeStyle({
                                                    '--focus-border-color': modalInputFocusBorder.value,
                                                    '--focus-ring-color': modalInputFocusRing.value
                                                }),
                                                placeholder: "0123 456789"
                                            }, null, 4 /* STYLE */), [
                                                [_vModelText, localData.value.phone]
                                            ])
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ]),
                                _createCommentVNode(" Modal Footer "),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("button", {
                                        onClick: closeModal,
                                        class: "flex-1 px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-100 transition-colors font-semibold"
                                    }, " Abbrechen "),
                                    _createElementVNode("button", {
                                        onClick: saveData,
                                        disabled: !isValid.value,
                                        class: _normalizeClass(["modal-primary-btn flex-1 px-4 py-3 rounded-xl font-semibold transition-colors border-2", !isValid.value ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300' : '']),
                                        style: _normalizeStyle(isValid.value ? {
                                            backgroundColor: modalButtonPrimary.value,
                                            borderColor: modalButtonPrimary.value,
                                            color: '#FFFFFF'
                                        } : {})
                                    }, " Speichern ", 14 /* CLASS, STYLE, PROPS */, _hoisted_6)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
